import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	PetitionDetailsShareAssetAbImageQuery,
	PetitionDetailsShareAssetAbImageQueryVariables,
} from './getPetitionShareAssetAbImage.graphql';
import { PetitionDetailsShareAssetAbImage } from './getPetitionShareAssetAbImage.graphql';

/**
 * The share asset A/B image a `/sa/:experimentName/:variant` link previews, or undefined to serve the `/bsv` image.
 */
export async function getPetitionShareAssetAbImage(
	params: PetitionDetailsShareAssetAbImageQueryVariables,
	{ gql: { fetch } }: UtilityContext,
): Promise<string | undefined> {
	const { data } = await fetch<PetitionDetailsShareAssetAbImageQuery, PetitionDetailsShareAssetAbImageQueryVariables>({
		query: PetitionDetailsShareAssetAbImage,
		variables: params,
		rejectOnError: true,
	});
	return data.petitionBySlugOrId?.shareAssetAbImageUrl ?? undefined;
}
